<template>
  <FlashNotifications ref="flash" />

  <div class="flex flex-col items-center justify-center py-24 text-center px-4">
    <div class="w-16 h-16 rounded-2xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center mb-5">
      <svg class="w-7 h-7 text-blue-500 dark:text-blue-400" fill="none" stroke="currentColor" stroke-width="1.75" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
      </svg>
    </div>
    <h3 class="text-base font-semibold text-gray-900 dark:text-white">Plan and billing</h3>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1.5 max-w-sm">
      Plan management and billing for organizations are coming soon.
    </p>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import FlashNotifications from 'controllers/vue_components/flash_toast'

const flash = ref(null)
</script>
